<template>
  <component
    :is="component"
    v-intersect="trackImpressions ? onVisible : undefined"
    v-bind="itemProps"
    :list-style="listStyle"
    :user-id="userId"
    :public-mode="publicMode"
    @action="onAction"
    @filter-tags="$emit('filter-tags', $event)"
  />
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { ResourceType } from '@/utils/constants'
import BookmarkItem from './BookmarkItem.vue'
import NoteItem from './NoteItem.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  userId: {
    type: String,
    default: null,
  },
  membership: {
    type: Object,
    default: null,
  },
  listStyle: {
    type: String,
    default: 'card',
  },
  publicMode: {
    type: Boolean,
    default: false,
  },
  // Emit `impression` when this item card scrolls into view (public pages)
  trackImpressions: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['action', 'filter-tags', 'impression'])

const isBookmark = computed(() => {
  return props.item.resourceType === ResourceType.BOOKMARK
})

const isNote = computed(() => {
  return props.item.resourceType === ResourceType.NOTE
})

const component = computed(() => {
  if (isBookmark.value) return BookmarkItem
  if (isNote.value) return NoteItem
  // Default to bookmark for backward compatibility
  return BookmarkItem
})

const itemProps = computed(() => {
  if (isBookmark.value) {
    return { bookmark: props.item, membership: props.membership }
  }
  if (isNote.value) {
    return { note: props.item, membership: props.membership }
  }
  // Default to bookmark props
  return { bookmark: props.item, membership: props.membership }
})

function onAction(payload) {
  // Forward the action event with the item reference
  emit('action', payload)
}

// No `.once`: the virtual scroller recycles this card for other items; the parent's
// per-page Set and the backend dedup collapse repeats
function onVisible(isIntersecting) {
  if (isIntersecting) emit('impression', { itemId: props.item._id })
}
</script>
